import * as React from "react";
import styles from "./styles.module.css";

const Loader = ({ loading }: { loading: boolean }) => {
  return (
    <>
      {loading ? (
        <div className={styles.preloader}>
          <Spinner />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

interface SpinnerProps {
  className?: string;
}

const Spinner = ({ className = '' }: SpinnerProps) => {
  return <div className={`${styles.spinner} ${className}`}></div>;
};

export { Loader, Spinner };
